<script setup>
const modules = import.meta.glob('/src/assets/illustrations/*.svg', {
  query: '?raw',
  import: 'default',
  eager: true,
})
const svgs = Object.fromEntries(
  Object.entries(modules).map(([path, src]) => [
    path.replace('/src/assets/illustrations/', '').replace('.svg', ''),
    src,
  ])
)

defineProps({
  name: { type: String, required: true },
})
</script>

<template>
  <span class="illustration" aria-hidden="true" v-html="svgs[name]" />
</template>

<style scoped>
.illustration {
  display: inline-block;
  line-height: 0;
}

.illustration :deep(svg) {
  display: block;
  width: 100%;
  height: auto;
}
</style>
